import { Button } from './Button'
import { useNls } from '../../nls/nlsProvider'
import './rollSummaryBar.css'

export interface RollSummaryCounts {
  present: number
  absent: number
  late: number
  onLeave: number
}

export interface RollSummaryBarProps {
  counts: RollSummaryCounts
  actionLabel: string
  onAction: () => void
  busy?: boolean
  disabled?: boolean
  testId?: string
  countLabels?: {
    present?: string
    absent?: string
    late?: string
    onLeave?: string
  }
  className?: string
}

export const RollSummaryBar = ({
  counts,
  actionLabel,
  onAction,
  busy = false,
  disabled = false,
  testId,
  countLabels,
  className,
}: RollSummaryBarProps) => {
  const { t } = useNls()

  const labels = {
    present: countLabels?.present ?? t('NLSEduAttendanceStatusPresentShort') ?? 'P',
    absent: countLabels?.absent ?? t('NLSEduAttendanceStatusAbsentShort') ?? 'A',
    late: countLabels?.late ?? t('NLSEduAttendanceStatusLateShort') ?? 'L',
    onLeave: countLabels?.onLeave ?? t('NLSEduAttendanceStatusOnLeaveShort') ?? 'OL',
  }

  return (
    <div
      className={['rollSummaryBar', className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      <div className="rollSummaryBar__counts">
        <span
          className="rollSummaryBar__chip rollSummaryBar__chip--present"
          data-testid={testId ? `${testId}-count-present` : 'summary-count-present'}
        >
          <span>{labels.present}</span>
          <span>{counts.present}</span>
        </span>
        <span
          className="rollSummaryBar__chip rollSummaryBar__chip--absent"
          data-testid={testId ? `${testId}-count-absent` : 'summary-count-absent'}
        >
          <span>{labels.absent}</span>
          <span>{counts.absent}</span>
        </span>
        <span
          className="rollSummaryBar__chip rollSummaryBar__chip--late"
          data-testid={testId ? `${testId}-count-late` : 'summary-count-late'}
        >
          <span>{labels.late}</span>
          <span>{counts.late}</span>
        </span>
        <span
          className="rollSummaryBar__chip rollSummaryBar__chip--onLeave"
          data-testid={testId ? `${testId}-count-onLeave` : 'summary-count-onLeave'}
        >
          <span>{labels.onLeave}</span>
          <span>{counts.onLeave}</span>
        </span>
      </div>
      <div className="rollSummaryBar__action">
        <Button
          variant="primary"
          loading={busy}
          disabled={disabled || busy}
          onClick={onAction}
          data-testid={testId ? `${testId}-action-btn` : 'roll-summary-action-btn'}
        >
          {actionLabel}
        </Button>
      </div>
    </div>
  )
}

export default RollSummaryBar
